import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";
import { useContent } from "../lib/ContentContext";

export default function FAQ({ items, title, subtitle }) {
  const { t } = useContent();

  // If no items passed, build from content keys faq.q1/a1 .. faq.q6/a6
  const resolvedItems =
    items ||
    Array.from({ length: 6 }, (_, i) => ({
      q: t(`faq.q${i + 1}`, ""),
      a: t(`faq.a${i + 1}`, ""),
    })).filter((x) => x.q && x.a);

  const heading = title || t("faq.title", "Pertanyaan yang Sering Diajukan");
  const sub = subtitle || t("faq.subtitle", "");

  return (
    <section
      className="bg-[#F5F5F7] border-t border-[#E5E5EA]"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="flex items-start gap-4 mb-12">
          <HelpCircle className="w-6 h-6 mt-1 text-[#0F0F0F]" strokeWidth={1.5} />
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#6E6E73] mb-3">
              {t("faq.eyebrow", "FAQ")}
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#0F0F0F] leading-[1.1]">
              {heading}
            </h2>
            {sub && (
              <p className="mt-5 text-base text-[#6E6E73] leading-relaxed max-w-xl">
                {sub}
              </p>
            )}
          </div>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {resolvedItems.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="border-b border-[#E5E5EA]"
              data-testid={`faq-item-${idx}`}
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-medium text-[#0F0F0F] hover:no-underline py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-[#6E6E73] leading-relaxed pb-6 pr-4">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
